<p>
  <strong>{{ appCopy.panelHeader['amountChargedText'+selectedLanguage] }}</strong><br>
  {{currencySymbol === 'CHF' ? currencySymbol+' ' :
  currencySymbol}}{{ extraBagDoorstepPayment.totalCharge.toFixed(2) }}
</p>
<P>
  <strong>{{ appCopy.panelHeader['paymentStatusText'+selectedLanguage] }}</strong><br>
  {{ extraBagDoorstepPayment.paymentStatus === 1 ? appCopy.panelHeader['pendingText'+selectedLanguage] : extraBagDoorstepPayment.paymentStatus === 2 ? appCopy.panelHeader['settledText'+selectedLanguage] : '' }}
</P>
<p><strong>{{ appCopy.panelHeader['reasonText'+selectedLanguage] }}</strong><br>
  <span *ngIf="extraBagDoorstepPayment.extraBagQuantity > 0">
    {{ extraBagDoorstepPayment.extraBagQuantity }} {{ appCopy.panelHeader['extraText'+selectedLanguage] }} {{ extraBagDoorstepPayment.extraBagQuantity > 1 ? appCopy.panelHeader['bagsSelectText'+selectedLanguage] : appCopy.panelHeader['bagSelectText'+selectedLanguage] }}
  </span><br>
</p>
